// Google Ads / gtag conversion helper. Conversion labels come from env; when a label is
// empty only the plain GA-style event fires (no malformed send_to). Consent Mode in
// index.html governs cookie usage, so nothing here bypasses the cookie banner.
const ADS_ID = "AW-18509678234";
const LABELS = {
  sign_up: process.env.REACT_APP_GADS_SIGNUP_LABEL,
  onboarding_complete: process.env.REACT_APP_GADS_WELCOME_LABEL,
};

const onceKey = (name) => `fab_conv_${name}`;

export function trackConversion(name, params = {}) {
  if (typeof window.gtag !== "function") return false;
  try {
    if (sessionStorage.getItem(onceKey(name))) return false;
    sessionStorage.setItem(onceKey(name), "1");
  } catch { /* sessionStorage unavailable — fire anyway */ }
  const label = (LABELS[name] || "").trim();
  if (label) window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}`, ...params });
  window.gtag("event", name, params);
  return true;
}
